import { Prototype } from '../tree/prototype';
import { Secure } from '../base/secure';
import { Folder, Genus } from './genus';

export class Site extends Secure {
    static _type: string = 'Site';

    i_site: true = true;

    prototypeId?: string;
    prototype?: Prototype;
    data: any;

    constructor(source?: any) {
        super(source);

        if (!!source) {
            const { parent, nodes, prototype, ...rest } = source;

            this.data = rest.data;
            this.prototypeId = source.prototypeId;

            if (prototype) {
                this.prototype = new Prototype(prototype);
            }
        }
    }

    override copy(source: any) {
        super.copy(source);

        if (!!source) {
            const { parent, nodes, prototype, ...rest } = source;

            this.data = rest.data;
            this.prototypeId = source.prototypeId;

            if (prototype) {
                this.prototype = new Prototype(prototype);
            }
        }
    }

    get model(): any {
        const { prototype, ...rest } = super.model;
        return rest;
    }

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { prototype, branches } = source;
            this.prototype = new Prototype(prototype);
            this.prototype.load();

            branches?.forEach((branch: any) => {
                if (branch?.i_folder) {
                    const folder = new Folder(branch);
                    this.branches.push(folder);
                } else if (branch?.i_genus) {
                    const genus = new Genus(branch);
                    this.branches.push(genus);
                }
            });
        }
    }

    override fit(branch: any): boolean {
        return false;
    }
}
